import { Controller, useFieldArray, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { DataType } from '../types';
import { Button } from 'components/shadcn/button';
import { Input } from 'components/shadcn/input';
import { Label } from 'components/shadcn/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from 'components/shadcn/select';
import { Plus, Trash2 } from 'lucide-react';

export const MetadataFieldRepeater = () => {
  const { t } = useTranslation();
  const { control } = useFormContext();
  const { fields, append, remove } = useFieldArray({ control, name: 'metadataFields' });

  return (
    <div>
      {fields.map((field, index) => (
        <div key={field.id} className="grid grid-cols-1 md:grid-cols-12 gap-2 mb-2 items-center">
          <div className="col-span-1 md:col-span-4">
            <Label htmlFor={`metadataFields.${index}.name`} className="mb-1 block">
              {t('dashboard.metadataFields.fieldName')}
            </Label>
            <Controller
              name={`metadataFields.${index}.name`}
              control={control}
              render={({ field }) => (
                <Input id={`metadataFields.${index}.name`} {...field} className="w-full" />
              )}
            />
          </div>
          <div className="col-span-1 md:col-span-4">
            <Label htmlFor={`metadataFields.${index}.description`} className="mb-1 block">
              {t('dashboard.metadataFields.description')}
            </Label>
            <Controller
              name={`metadataFields.${index}.description`}
              control={control}
              render={({ field }) => (
                <Input id={`metadataFields.${index}.description`} {...field} className="w-full" />
              )}
            />
          </div>
          <div className="col-span-1 md:col-span-3">
            <Label htmlFor={`metadataFields.${index}.dataType`} className="mb-1 block">
              {t('dashboard.metadataFields.dataType')}
            </Label>
            <Controller
              name={`metadataFields.${index}.dataType`}
              control={control}
              render={({ field }) => (
                <Select value={field.value} onValueChange={field.onChange}>
                  <SelectTrigger className="w-full">
                    <SelectValue placeholder={t('dashboard.metadataFields.selectDataType')} />
                  </SelectTrigger>
                  <SelectContent>
                    {Object.values(DataType).map((type: string) => (
                      <SelectItem key={type} value={type}>
                        {type}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              )}
            />
          </div>
          <div className="col-span-1 md:col-span-1 flex justify-center md:justify-end md:pt-6">
            <Button
              type="button"
              variant="ghost"
              size="icon"
              onClick={() => remove(index)}
              className="text-destructive"
            >
              <Trash2 className="h-4 w-4" />
            </Button>
          </div>
        </div>
      ))}
      <div className="mt-2">
        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={() => append({ name: '', description: '', dataType: DataType.STRING })}
          className="flex items-center gap-2"
        >
          <Plus className="h-4 w-4" />
          <span>{t('dashboard.metadataFields.addField')}</span>
        </Button>
      </div>
    </div>
  );
};
